{
	"title": "Dichiarazioni",
	"table": {
		"material": "Materiale",
		"dateOfIssue": "Data di emissione",
		"quantity": "Quantità",
		"carbonSavings": "Riduzioni di carbonio",
		"status": {
			"title": "Stato",
			"TransactionProcessing": "Elaborazione della transazione",
			"CreatingDeclaration": "Creazione della dichiarazione",
			"GenerationFailed": "Generazione non riuscita",
			"ReadyToDownload": "Pronto per il download"
		}
	},
	"declarationLanguageSelect": {
		"title": "Lingua della dichiarazione",
		"description": "Seleziona una lingua per la dichiarazione.",
		"label": "Lingua della dichiarazione",
		"buttonBack": "Indietro",
		"buttonSave": "Salva"
	},
	"downloadAllLanguageSelect": {
		"title": "Lingue delle dichiarazioni",
		"descriptionGlobal": "Seleziona una lingua per tutte le dichiarazioni.",
		"descriptionIndividual": "Oppure imposta la lingua per ogni dichiarazione individualmente.",
		"label": "Lingue delle dichiarazioni",
		"tableHeaderDeclaration": "Dichiarazione (materiale/data di emissione)",
		"tableHeaderLanguage": "Lingua della dichiarazione",
		"buttonBack": "Indietro",
		"buttonDownload": "Scarica dichiarazioni"
	},
	"declarationActions": {
		"changeLanguage": "Modifica la lingua della dichiarazione",
		"preview": "Anteprima",
		"download": "Scarica",
		"transaction": "Transazione",
		"showMoreTransactions": "Mostra più transazioni",
		"languageLabel": "Lingua della dichiarazione",
		"downloadAll": "Scarica tutte le dichiarazioni"
	}
}
